module.exports = __webpack_public_path__ + "img/equipos-de-sala-gal-3-zoom.abdf0bf5.png";